import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';

const Cover = ({ context }) => {
	
	const ctxSiteLoaded 	= () => context.siteLoaded;
	const siteLoaded 		= ctxSiteLoaded();
		
	return (
		<div className="c-cover"></div>
	)
	
}
export default WithConsumer(Cover);